import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoCertificazioneUnicaStep2Component } from './conservazione-carica-documento-certificazione-unica-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-certificazione-unica-step2', {
            url: '/conservazione-carica-certificazione-unica',
            ncyBreadcrumb: {
                label: 'Carica Certificazione Unica',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-certificazione-unica-step2 flex="100"></conservazione-carica-documento-notifiche-sdi-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoCertificazioneUnicaStep2Module: string = ng
    .module('conservazione-carica-documento-certificazione-unica-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoCertificazioneUnicaStep2', ConservazioneCaricaDocumentoCertificazioneUnicaStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-certificazione-unica-step2/conservazione-carica-documento-certificazione-unica-step2.module.ts